import { getOptimizelyClient } from '@features/Optimisely/Provider';

import { signupOptimizelyActiveExperimentsEntity } from '../trackingEvents';

/**
 * Builds a `signup_optimizely_active_experiments` Snowplow entity from the
 * current Optimizely decision state. Returns an empty array when no
 * experiments are active so callers can spread directly without branching.
 *
 * Uses `decideAll()` which is synchronous and deterministic (userId +
 * cached datafile), so it is safe to call inside event callbacks.
 */
export const buildOptimizelyEntity = () => {
  const decisions = getOptimizelyClient().decideAll();

  const activeExperiments = Object.values(decisions)
    .filter((d) => d.enabled)
    .map((d) => ({
      flag_key: d.flagKey,
      variation_key: d.variationKey ?? '',
      enabled: d.enabled,
      rule_key: d.ruleKey ?? '',
    }));

  if (!activeExperiments.length) return [];

  return [
    signupOptimizelyActiveExperimentsEntity({ experiments: activeExperiments }),
  ];
};
